module.exports = __webpack_public_path__ + "static/media/dashboard_instagram_icon.107ca7cf.svg";